import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MapActions } from "../../_actions";
import { MapListItem } from "../_components";
import { useModal, useMaps } from "../../_contexts";
import { Button, Icon } from "../../_components";
import { useEventListener } from "../../_hooks";

export function MapListForm(props) {
  const [filteredMaps, setFilteredMaps] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const { items: maps } = useSelector((state) => state.maps);
  // const { maps } = props;
  const { currentMap, goToMap } = useMaps();
  const dispatch = useDispatch();
  // console.log('Map Manager: List', maps);

  const { openModal, closeModal } = useModal();
  const handleMapDelete = (id) => {
    // console.log('Deleting Map: ' + id);
    // dispatch(MapActions.deleteMapById(id));
    const map = maps.find((m) => m._id === id);
    openModal("confirmDelete", {
      prevModal: "mapManager",
      type: "map",
      item: map,
      text: "This will remove the selected map and ALL associated markers!",
    });
  };

  const handleMapEdit = (id) => {
    //get map
    const map = maps.find((m) => m._id === id);
    // console.log('Editing Map: ' + map.title);
    openModal("editMap", { mapItem: map, prevModal: "mapManager" });

    //load new/edit form with params
  };

  const handleMapSelect = (map) => {
    const coords = {
      x: map.options.coordX,
      y: map.options.coordY,
      z: map.options.zoomDefault,
    };
    // console.log('Selected Map: ', map, coords);
    goToMap(map._id, coords);
    closeModal();
  };

  const handleMapCreate = (ev) => {
    openModal("newMap", { prevModal: "mapManager" });
  };

  const handleSearchChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };

  const handleFormClose = (ev) => {
    closeModal();
  };

  useEffect(() => {
    setFilteredMaps(maps);
  }, [maps]);

  useEffect(() => {
    if (searchVal && searchVal.length > 0) {
      const results = maps.filter((map) => {
        if (map.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
          return true;
        }
        return false;
      });
      setFilteredMaps(results);
    }
  }, [searchVal]);

  const handleKeyClose = (ev) => {
    if (ev.key && ev.key.toLowerCase() === "escape") {
      handleFormClose();
    }
  };

  useEventListener("keyup", handleKeyClose);

  const mapItems = filteredMaps.map((map) => (
    <MapListItem
      mapItem={map}
      key={map._id}
      controls
      onDelete={handleMapDelete}
      onEdit={handleMapEdit}
      onSelect={handleMapSelect}
      active={currentMap && map._id === currentMap._id}
    />
  ));

  return (
    <div className="chronos-map-list-form chronos-map-manager chronos-list-form">
      <div className="chronos-list-header">
        <div className="chronos-list-search">
          <input
            type="text"
            value={searchVal}
            onChange={handleSearchChange}
            placeholder="Search Maps"
            className="chronos-search-input chronos-input form-control"
          />
          <Icon icon="fas fa-search fa-fw" />
        </div>
        <div className="chronos-list-options">
          <Button color="success" onClick={handleMapCreate}>
            <Icon icon="fas fa-plus fa-fw" />
            New Map
          </Button>
        </div>
      </div>
      {filteredMaps && filteredMaps.length > 0 && (
        <ul className="chronos-map-list">{mapItems}</ul>
      )}
      {(!filteredMaps || filteredMaps.length === 0) && (
        <h4 className="chronos-no-results">No Maps to Display</h4>
      )}
      <div className="form-controls">
        &nbsp;
        {/* <Button color="primary" onClick={handleFormClose}>
          <Icon icon="fas fa-times fa-fw" />
          Close
        </Button> */}
      </div>
    </div>
  );
}
